// Bundled by Vite from /branding/assets (see ui/vite.config.ts alias @iox-bridge-branding).
// Replace branding/assets/login-background.png at the repo root, then rebuild the UI / image.
import loginBackgroundImageUrl from "@iox-bridge-branding/login-background.png?url";
import loginLogoLightImageUrl from "@iox-bridge-branding/logo-light.svg?url";

export const IOX_BRANDING = {
  productName: "ioX-Bridge",
  uiVersion: "1.0.6",
  supportUrl: "https://www.iox-connect.com/reach-out",
  docsUrl: "https://bridgedocs.ioxapp.net",
  titleSuffix: "ioX-Bridge LoRaWAN® Network-Server",
  loginBackgroundImageUrl,
  /** Split login left column (light panel) — `logo-light.svg` from branding assets. */
  loginLogoImageUrl: loginLogoLightImageUrl,
} as const;
